export class HttpKanbanGateway {
  constructor({ httpClient, apiBaseUrl }) {
    this.httpClient = httpClient;
    this.apiBaseUrl = apiBaseUrl;
  }

  async list({
    page = 1,
    limit = 100,
    status = "",
    cliente = "",
    search = "",
  } = {}) {
    const params = new URLSearchParams({
      page: String(page),
      limit: String(limit),
    });

    if (status) {
      params.set("status", status);
    }

    if (cliente) {
      params.set("cliente", cliente);
    }

    if (search) {
      params.set("search", search);
    }

    return this.httpClient.get(
      `${this.apiBaseUrl}/kanban/list?${params.toString()}`,
    );
  }

  async getSyncDiagnostics() {
    return this.httpClient.get(`${this.apiBaseUrl}/kanban/diagnostics/sync`);
  }
}